module.exports = __webpack_public_path__ + "img/anzhuang.43ec8bad.png";